<template>
    <div>
        <div class="jquery-ui-scope view bpms-timesheetForm"></div>
    </div>
</template>
<script type="text/javascript">
    import loading from '../widgets/loading/loading.vue';
    export default {
        data() {
            return {
            }
        },
        methods: {

        },
        mounted() {
            const container = $('.bpms-timesheetForm', this.$el);
            const params = {
                element: container,
                fromMenu: true
            };
            var obj = {
                    id: '',
                    cmp: false
                };
            vm.timesheet.activate(obj,params);
        },
        components: {
            loading
        }
    }
</script>
